module.exports = __webpack_public_path__ + "fonts/Montserrat-VariableFont_wght.a3fcdff0.ttf";